import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  defaultBorderColor: '#f3f3f3'
} satisfies RecursivePartial<CMSConfig['accordion']>
